import { render, staticRenderFns } from "./layout-loader.vue?vue&type=template&id=d70aeb5e&scoped=true&"
var script = {}
import style0 from "./layout-loader.vue?vue&type=style&index=0&id=d70aeb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70aeb5e",
  null
  
)

export default component.exports